<template>
  <div class="middle">
    <v-container style="width:400px;">
      <h1>TN BOX ADMIN LOGIN</h1>
      <v-text-field ref="login-id" v-model="loginId" :maxlength="MAXLENGTH.USER.ID" :rules="[RULES.loginId]"
                    outlined
                    :label="'아이디' | translate"
                    @keyup.enter="$refs['login-pw'].focus()"
      />
      <v-text-field
        ref="login-pw" v-model="password" :maxlength="MAXLENGTH.USER.PASSWORD" :rules="[RULES.password]" outlined
        type="password" :label="'비밀번호' | translate"
        @keyup.enter="onClickLogin"
      />
      <v-btn block color="primary" @click="onClickLogin">
        {{ TRANS.LOGIN }}
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import LoginMixin from "./mixins/LoginMixin";
// import-excel LoginMixin from "@/views/welcome/login/mixins/LoginMixin";

export default {
  name: "Login",
  mixins: [LoginMixin],
  methods: {},
}
</script>

<style scoped>

.middle {
  margin: 0 auto;
}

</style>